module.exports = __webpack_public_path__ + "img/b6_02.ce80c957.jpg";